module.exports = (__webpack_require__(0))(126);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/AdminView.js from dll-reference girder_lib
// module id = 41
// module chunks = 0